const LOCALES = {
  ENGLISH: "en",
  UKRAINIAN: "uk",
  GERMAN: "de",
  SPANISH: "es",
  FRENCH: "fr"
};

const LOCALES_LIST = [
  LOCALES.ENGLISH,
  LOCALES.UKRAINIAN,
  LOCALES.GERMAN,
  LOCALES.SPANISH,
  LOCALES.FRENCH
];

const localeCodeToLabel = {
  [LOCALES.ENGLISH]: "English",
  [LOCALES.UKRAINIAN]: "Ukrainian",
  [LOCALES.GERMAN]: "German",
  [LOCALES.SPANISH]: "Spanish",
  [LOCALES.FRENCH]: "French",
};

export {
  LOCALES, LOCALES_LIST, localeCodeToLabel
};
